import { ChildGender } from "~/types";

export const formatAgeGenderEmoji = (
  age: number | null | undefined,
  gender: ChildGender | undefined,
): string => {
  const ageNum = age ?? 0;

  if (gender === "boy") {
    switch (ageNum) {
      case 0:
        return "👶";
      case 1:
        return "👶";
      case 2:
        return "👦";
      case 3:
        return "👦";
      case 4:
        return "👦";
      case 5:
        return "🧒";
      case 6:
        return "🧒";
      case 7:
        return "🧒";
      default:
        return "🧒";
    }
  } else if (gender === "girl") {
    switch (ageNum) {
      case 0:
        return "👶";
      case 1:
        return "👶";
      case 2:
        return "👧";
      case 3:
        return "👧";
      case 4:
        return "👧";
      case 5:
        return "🧒";
      case 6:
        return "🧒";
      case 7:
        return "🧒";
      default:
        return "🧒";
    }
  }

  // Default (no gender) - ALL KID EMOJIS
  switch (ageNum) {
    case 0:
      return "👶";
    case 1:
      return "👶";
    case 2:
      return "🧒";
    case 3:
      return "🧒";
    case 4:
      return "🧒";
    case 5:
      return "🧒";
    case 6:
      return "🧒";
    case 7:
      return "🧒";
    default:
      return "🧒";
  }
};
